export const REMOVE_COUNTRIES = [
    'Syria',
    'United States'
]